import moment from 'moment';

export const getDateFromLocalToUTC=localDate=>{
  const offSetMinutes = moment().local().utcOffset()
  if(offSetMinutes!=0){
    return moment.utc(localDate).add(1,'days').local().format('YYYY-MM-DD')
    //return moment.utc(localDate).format('YYYY-MM-DD');
  }else{
    return moment.utc(localDate).format('YYYY-MM-DD');
  }
}


export const getDateFromUTCToLocal=localDate=>{
  const offSetMinutes = moment().local().utcOffset()
  if(offSetMinutes<0){
    return moment.utc(localDate).subtract(1,'days').toISOString()
  }else if(offSetMinutes>0){
    return moment.utc(localDate).add(1,'days').toISOString()
  }else{
    return localDate;
  }
}

export const formatDate = date => {
  if(date != null)
    return moment(date).format('DD - MM - YYYY');
  return null;
}

export const formatDateTime = date => {
  return moment(date).format('DD-MM-YYYY h:mm:ss a');
}

export const getDate= () =>{
  return moment().local().format('YYYY-MM-DD');
}



// WEBPACK FOOTER //
// ./src/helpers/date-methods.js